var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "slider" }, [
    _c(
      "div",
      { staticClass: "slider_wrapper" },
      [
        _c(
          "swiper",
          {
            ref: "slider",
            staticClass: "swiper component",
            attrs: { options: _vm.swiperComponentOption },
          },
          [
            _vm._l(_vm.totalSlides, function (slide, index) {
              return _c(
                "swiper-slide",
                { key: index },
                [_vm._t("slide-" + index)],
                2
              )
            }),
            _c("div", {
              staticClass: "swiper-pagination",
              attrs: { slot: "pagination" },
              slot: "pagination",
            }),
            _c(
              "div",
              {
                staticClass: "swiper-button-prev",
                attrs: { slot: "button-prev" },
                slot: "button-prev",
              },
              [
                _c("svgicon", {
                  staticClass: "icon",
                  attrs: { name: "arrow_right" },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "swiper-button-next",
                attrs: { slot: "button-next" },
                slot: "button-next",
              },
              [
                _c("svgicon", {
                  staticClass: "icon",
                  attrs: { name: "arrow_right" },
                }),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }